import type { NextSeoProps } from 'next-seo';

export const SEO: NextSeoProps = {
  title: 'JSON2Diagram | Baris Aydin',
  description:
    'JSON2Diagram Editor is a versatile tool for visualizing, analyzing, and editing data formats like JSON, CSV, YAML, and XML. It supports formatting, querying, transforming, and validating data with ease.',
  themeColor: '#36393E',
  openGraph: {
    type: 'website',
    images: [
      {
        url: 'https://json-to-diagram.devsolux.net/logo.png',
        width: 1200,
        height: 627,
      },
    ],
  },
  twitter: {
    handle: '@devsolux',
    cardType: 'summary_large_image',
  },
  additionalLinkTags: [
    {
      rel: 'manifest',
      href: '/manifest.json',
    },
    {
      rel: 'icon',
      href: '/favicon.ico',
      sizes: '48x48',
    },
  ],
};
